import axios from "axios";
import * as ActionTypes from "../actions/ActionTypes";
import { createTourismEvent, updateTourismEvent } from "./TourismEvents";

export const uploadingImage = imageUrl => {
  return {
    type: ActionTypes.UPLOADING_IMAGE,
    imageUrl: imageUrl
  };
};

export const uploadImage = (formData, config, event, onFinishedUpload) => {
  return dispatch => {
    axios
      .post(
        "http://190.105.227.203/baroloapi/uploadimagetourism",
        formData,
        config
      )
      .then(response => {
        dispatch(uploadingImage(response.data));
        event.imageurl = "http://" + response.data;
        dispatch(updateTourismEvent(event));
      })
      .catch(error => {
        alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
      });
  };
};

export const uploadImageAndCreateEvent = (formData, config, event) => {
  return dispatch => {
    axios
      .post(
        "http://190.105.227.203/baroloapi/uploadimagetourism",
        formData,
        config
      )
      .then(response => {
        dispatch(uploadingImage(response.data));
        event.imageUrl = "http://" + response.data;

        dispatch(createTourismEvent(event));
      })
      .catch(error => {
        alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
      });
  };
};
